import React from 'react';
import {
  Modal,
  Animated,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import {Colors} from '../../constants/Colors';
import {styles} from './styles';

interface NotificationPermissionModalProps {
  visible: boolean;
  onClose: () => void;
  onAllow: () => void;
}

const NotificationPermissionModal: React.FC<
  NotificationPermissionModalProps
> = ({visible, onClose, onAllow}) => {
  const insets = useSafeAreaInsets();
  const slideAnim = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    Animated.spring(slideAnim, {
      toValue: visible ? 1 : 0,
      useNativeDriver: true,
      tension: 65,
      friction: 11,
    }).start();
  }, [visible, slideAnim]);

  const translateY = slideAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [600, 0],
  });

  return (
    <Modal
      key={visible ? 'visible' : 'hidden'}
      transparent={true}
      presentationStyle="overFullScreen"
      visible={visible}
      onRequestClose={onClose}
      animationType="none">
      <View style={styles.centeredView}>
        <Animated.View
          style={[
            styles.modalView,
            {
              transform: [{translateY}],
              paddingBottom: Math.max(insets.bottom, 20),
            },
          ]}>
          <View style={styles.handle} />

          <Text style={styles.title}>
            Ative as notificações e fique por dentro das novidades
          </Text>

          <ButtonComponent
            title="Permitir notificações"
            width="100%"
            backgroundColor={Colors.BluePallete.blue}
            onPress={onAllow}
          />

          <TouchableOpacity
            style={styles.laterButton}
            activeOpacity={0.7}
            onPress={onClose}>
            <Text style={styles.laterText}>Agora não</Text>
          </TouchableOpacity>
        </Animated.View>
      </View>
    </Modal>
  );
};

export default NotificationPermissionModal;
